

import {
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar, IonTabs, IonTabBar, IonTabButton, IonButtons,
  IonFab,
  IonFabButton,
  IonIcon,
  IonMenu,
  IonMenuButton,
  IonList,
  IonLabel,
  IonItem
} from '@ionic/vue';
import HomeButton from "@/components/HomeButton.vue";

import {
  add, cash, logOut, statsChart, star,bandage
} from "ionicons/icons";

import {defineComponent} from 'vue';
import {createI18n, useI18n} from "vue-i18n";
import {RouterLink, useRouter} from "vue-router";
import firebase from "firebase";

const translations = {
  "de": {
    "tabs": {
      "timeline": "Timeline",
      "goals": "Goals",
      "reviews": "Reviews",
      "toolbox": "Toolbox"
    }
  }
}
export default defineComponent({
  name: 'Home',
  components: {
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonButtons,
    IonContent,
    IonIcon,
    IonFabButton,
    IonFab,
    RouterLink,
    HomeButton,
    IonMenu,
    IonMenuButton,
    IonList,
    IonLabel,
    IonItem
  },
  methods: {
    goto(path: string) {
      this.router.push(path)
    },
    logout() {
      firebase.auth().signOut().then(r => this.router.push('/'));
    },
    donate() {
      console.log("donate");
    },
    stats() {

      this.router.push({name:'Stats'});
    }
  },
  setup() {

    const router = useRouter();
    const {t, locale} = useI18n({messages: translations})
    return {t, locale, router, add, cash, star, bandage, logOut, statsChart}

  }
});
